import { useSiteSettings } from "../../../contexts/SiteSettingsContext";
import type { SectionConfig } from "../../../types/settings";

export default function SectionsTab() {
  const { settings, updateSettings } = useSiteSettings();

  const sorted = [...settings.sections].sort((a, b) => a.order - b.order);

  const toggle = (id: string) => {
    updateSettings({
      sections: settings.sections.map((s) =>
        s.id === id ? { ...s, enabled: !s.enabled } : s
      ),
    });
  };

  const move = (id: string, direction: "up" | "down") => {
    const arr = [...sorted];
    const idx = arr.findIndex((s) => s.id === id);
    const swapIdx = direction === "up" ? idx - 1 : idx + 1;
    if (swapIdx < 0 || swapIdx >= arr.length) return;
    const newArr: SectionConfig[] = arr.map((s, i) => {
      if (i === idx) return { ...arr[swapIdx], order: idx };
      if (i === swapIdx) return { ...arr[idx], order: swapIdx };
      return { ...s, order: i };
    });
    updateSettings({ sections: newArr });
  };

  return (
    <div>
      <h3 className="text-sm font-bold text-gray-700 mb-2 pb-2 border-b border-gray-200">セクション管理</h3>
      <p className="text-xs text-gray-400 mb-4">表示/非表示の切り替えと並び替えができます。</p>

      <div className="space-y-2">
        {sorted.map((section, idx) => (
          <div
            key={section.id}
            className="flex items-center gap-3 bg-white border border-gray-200 rounded-lg px-4 py-3"
          >
            {/* 上下ボタン */}
            <div className="flex flex-col gap-0.5">
              <button
                onClick={() => move(section.id, "up")}
                disabled={idx === 0}
                className="w-6 h-5 flex items-center justify-center text-gray-400 hover:text-gray-700 disabled:opacity-20 cursor-pointer disabled:cursor-not-allowed"
              >
                <i className="ri-arrow-up-s-line text-sm" />
              </button>
              <button
                onClick={() => move(section.id, "down")}
                disabled={idx === sorted.length - 1}
                className="w-6 h-5 flex items-center justify-center text-gray-400 hover:text-gray-700 disabled:opacity-20 cursor-pointer disabled:cursor-not-allowed"
              >
                <i className="ri-arrow-down-s-line text-sm" />
              </button>
            </div>

            {/* ドラッグハンドル風アイコン */}
            <div className="w-4 h-4 flex items-center justify-center text-gray-300">
              <i className="ri-draggable text-sm" />
            </div>

            {/* セクション名 */}
            <span className="flex-1 text-sm text-gray-700">{section.label}</span>

            {/* 順番バッジ */}
            <span className="text-xs text-gray-400 w-6 text-center">{idx + 1}</span>

            {/* トグル */}
            <button
              onClick={() => toggle(section.id)}
              className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors cursor-pointer ${
                section.enabled ? "bg-red-500" : "bg-gray-200"
              }`}
              aria-label={section.enabled ? "非表示にする" : "表示にする"}
            >
              <span
                className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${
                  section.enabled ? "translate-x-[18px]" : "translate-x-[3px]"
                }`}
              />
            </button>
            <span className="text-xs text-gray-400 w-12">{section.enabled ? "表示中" : "非表示"}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
